"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = void 0;
const React = __importStar(require("react"));
require("./styles.scss");
const Title = (props) => {
    const { children, tag = "h1", isHighlighted = false, title = "", className = "", onClick } = props;
    const TagType = tag;
    const [first, ...other] = title.split(" ");
    const isInteractive = Boolean(onClick);
    const rootClassNames = `c-title ${isInteractive ? "c-title__interactive" : ""} ${className}`;
    return (React.createElement(TagType, { onClick: onClick, className: rootClassNames },
        isHighlighted ? React.createElement("span", { className: "c-title__colored" }, first) : first,
        " " + other.join(" "),
        children));
};
exports.Title = Title;
